"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STREET = exports.FLOOR = exports.APT = void 0;
exports.APT = "apartment";
exports.FLOOR = "floor";
exports.STREET = "street";